export class EntKurultaiRegisterFilter {
	page: number
	size: number
	executionStatusIds: number[] | null
	territorialUnitIds: number[] | null
	regionIds: number[] | null
	questionCategoryIds: number[] | null
	responsibleAuthority: string | null
	deadlineDateFrom: string | null
	deadlineDateTo: string | null
	assemblyNumber: string | null
	assemblyDateFrom: string | null
	assemblyDateTo: string | null
	delegateName: string | null
	taskIds: number[] | null
	deleted?: boolean | null

	constructor(init?: Partial<EntKurultaiRegisterFilter>) {
		this.page = 1
		this.size = 30
		this.executionStatusIds = null
		this.territorialUnitIds = null
		this.regionIds = null
		this.questionCategoryIds = null
		this.responsibleAuthority = null
		this.deadlineDateFrom = null
		this.deadlineDateTo = null
		this.assemblyNumber = null
		this.assemblyDateFrom = null
		this.assemblyDateTo = null
		this.delegateName = null
		this.taskIds = null
		this.deleted = false
		if (init) {
			Object.assign(this, init)
		}
	}
}
